(() => {
	const INSTANCES = []
	class CityDomainsPopup {
		constructor (id, base, path, citypage) {
			INSTANCES.push(this)
			this.id = id
			this.base = base
			this.path = path
			this.citypage = citypage
			this.cookieName = 'city'
			document.addEventListener('DOMContentLoaded', this.init.bind(this))
		}

		static get INSTANCES () {
			return INSTANCES
		}

		init () {
			this.container = document.getElementById(this.id)
			this.popup = document.getElementById('popup_cities')
			this.bindLink()
			this.bindPopup()
			this.closePopup()
			// console.log(this)
		}

		bindLink () {
			let list = document.querySelectorAll('a[href*=wybierz-miasto]');
			[...list].forEach(element => {
				element.addEventListener('click', this.handleClick.bind(this))
			}
			)
		}

		bindPopup () {
			let list = this.popup.getElementsByClassName("popup--city--link");
			[...list].forEach(element => {
				element.addEventListener('click', this.handlePopup.bind(this))
			})
		}

		handleClick (event) {
			if (!this.getCookie(this.cookieName)) {
				let href = event.currentTarget.getAttribute('href')
				let flag = href.search('wybierz-miasto')
				href = href.substring(flag)
				this.route = href.replace('wybierz-miasto/', '')
				event.preventDefault()
				this.popup.style.display = 'block'
				return false
			}

		}

		handlePopup (event) {
			event.preventDefault()
			let city = event.target.getAttribute('data-city')
			let d = new Date()
			d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000))
			let expires = 'expires=' + d.toUTCString()
			document.cookie = this.cookieName + '=' + city + ';' + expires + ';path=/'

			window.location.href = this.base + city + '/' + this.route
		}

		closePopup () {
			const closeBtn = document.querySelector('.close__popup')
			closeBtn.addEventListener('click', () => this.popup.style.display="none")
		}

		getCookie () {
			let name = this.cookieName + '='
			let decodedCookie = decodeURIComponent(document.cookie)
			let ca = decodedCookie.split(';')
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i]
				while (c.charAt(0) === ' ') {
					c = c.substring(1)
				}
				if (c.indexOf(name) === 0) {
					return c.substring(name.length, c.length)
				}
			}
			return ''
		}
	}
	if (window.CityDomainsPopup === undefined) { window.CityDomainsPopup = CityDomainsPopup }
})()



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_choose_city_popup/script.js